import { PageViewEventLogger } from '@repo/tracking-service';

import { SurveyLayout } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { StartSurveyContainer } from '@/components/survey/start/StartSurveyContainer';

function SurveyStartPage() {
  const eventAttributes = useSurveyUserEventAttributes();

  return (
    <PageViewEventLogger pageName={'survey_start'} eventProperty={eventAttributes}>
      <StartSurveyContainer />
    </PageViewEventLogger>
  );
}

SurveyStartPage.getLayout = SurveyLayout;

export default SurveyStartPage;
